<template>
  <div class="get-pay">
    <Breadcrumb></Breadcrumb>
    <div class="pay-cont-box border pt20 pr20 pl20 pb30 border-t-no">
      <p class="font-bold f14">
        支付类型：<span class="pay-type">订单货款</span>
      </p>
      <div class="mt10 pay-table-box">
        <p class="font-bold f14 mt10 mb10">支付明细：</p>
        <el-table border ref="multipleTable" :data="tableData" class="table">
          <el-table-column
            type="index"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="appNo"
            label="订单编号"
            align="center"
          ></el-table-column>
          <el-table-column prop="proNum" label="总件数" align="center">
            <template slot-scope="scope">
              {{ scope.row.proNum }}（<span
                style="color:#ff7e00;font-weight:bold;"
                >vip{{ scope.row.vipType }}</span
              >）
            </template>
          </el-table-column>
          <el-table-column
            prop="proTotal"
            label="产品货款"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="embroideryCost"
            label="刺绣费用"
            align="center"
          >
            <template slot-scope="scope">
              ¥ {{ scope.row.embroideryCost ? scope.row.embroideryCost : 0 }}
            </template>
          </el-table-column>
          <el-table-column label="运费" align="center">
            <template slot-scope="scope"> ¥ {{ scope.row.proFare }} </template>
          </el-table-column>
          <el-table-column label="货款总计" align="center">
            <template slot-scope="scope">
              ¥ {{ scope.row.proActPay }}
            </template>
          </el-table-column>
          <el-table-column
            prop="shippingMethodName"
            label="物流方式"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="get-pay-box mb20">
        <div class="mt10 letter">
          <div class="display-flex font-bold f14 mt10 mb10">
            支付方式：
            <ul class="pay-tree pay vm">
              <li class="checked">
                <span class="coinTypeText">账户余额</span>
                <i class="el-icon-check check-icon"></i>
              </li>
            </ul>
          </div>
          <div class="recharge-bar mt5">
            <span class="mr30">支付账户：{{ user.userName }}</span>
            <span class="mr5">
              可用余额：
              <span class="cr refresh-amount">{{ user.balance }}</span>
              <span class="coinType">元</span>
            </span>
            <i
              @click="handleRefresh"
              style="cursor: pointer; margin: 0 8px 0 0"
              class="blue el-icon-refresh"
            ></i>
            <a
              class="recharge_btn"
              style="color: #4934b2; cursor: pointer"
              @click="handleCharge"
            >
              充值
            </a>
          </div>
        </div>
        <p class="font-bold f14 mt30">
          应付金额：<span class="f34 cr total-price">{{ proActPay }}</span
          ><span class="coinType">元</span>
        </p>
        <div class="mt20">
          <el-button type="primary" :disabled="!canPay" @click="handlePayOrder"
            >立即支付</el-button
          ><span
            style="
              color: red;
              margin: 0 0 0 19px;
              font-weight: bold;
              font-size: 14px;
            "
          >
            {{ hintText }}
            <a
              v-if="hintText == '请先实名认证后再付款'"
              @click="handleJump('/system/account/auth')"
              style="cursor: pointer"
              >点击认证</a
            >
          </span>
        </div>
        <div class="mt20 display-flex">
          <label class="display-flex"
            ><input
              class="agreeonBtn mr5"
              type="checkbox"
              checked="checked"
            /><span>我已经阅读并同意</span></label
          ><a class="blue o8" target="_blank">《平台定制物流协议》</a>,<a
            class="blue o8"
            target="_blank"
            >《平台定制售后政策》</a
          >和
          <a class="blue o8" target="_blank">《平台定制法律声明》</a>
        </div>
        <div class="title_record_style">
          上传图片或/和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="短信认证"
      :visible.sync="showConfirmDialog"
      width="362px"
    >
      <div style="margin: 8px 0 16px 0; font-size: 16px; padding: 0">
        支付金额：<span style="color: red">￥{{ proActPay }}</span>
      </div>
      <el-form>
        <el-form-item label="" prop="bt">
          <el-input
            v-model="validCode"
            style="width: 178px; margin: 0 16px 0 0"
          ></el-input>
          <el-button
            @click="sendValidCode"
            style="width: 126px; text-align: center"
          >
            {{ validText }}</el-button
          >
        </el-form-item>
      </el-form>
      <div>请输入{{ filterPhoneNumber(user.phoneNumber) }}收到的验证码</div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showConfirmDialog = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="handlePayOrder"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { listPay, orderPay, sendUserCodeSms, list1688 } from "@/api/order/all"
import { getUserProfile } from "@/api/system/user"

import { mapGetters } from "vuex"

export default {
  name: "getPay",
  components: { Breadcrumb },
  data() {
    return {
      id: this.$route.query.id,
      tableData: [],
      user: {
        userName: "",
        balance: 0,
      },
      proActPay: 0,
      showConfirmDialog: false,
      validCode: "",
      validText: "发送验证码",
      canSend: true,
      remain: 60,
    }
  },
  computed: {
    ...mapGetters(["user"]),
    accountName() {
      if (this.user && this.user.userType == "00") {
        return "管理员"
      } else if (this.user && this.user.userType == "01") {
        return "主账号"
      } else {
        return "子账号"
      }
    },
    canPay() {
      if (this.user && this.user.authStatus == "03") {
        return true
      } else {
        return false
      }
    },
    hintText() {
      if (this.user && this.user.authStatus == "03") {
        return ""
      } else if (this.user && this.user.userType == "01") {
        return "请先实名认证后再付款"
      } else {
        return "主账号未实名认证不能付款"
      }
    },
  },
  methods: {
    filterPhoneNumber(cellValue) {
      if (Number(cellValue) && String(cellValue).length === 11) {
        var mobile = String(cellValue)
        var reg = /^(\d{3})\d{4}(\d{4})$/
        return mobile.replace(reg, "$1****$2")
      } else {
        return cellValue
      }
    },
    handleCharge() {
      window.open("/system/account/recharge")
    },
    //格式化小计金额
    formatter(row) {
      return (row.subtotal + "").indexOf(".") != -1
        ? "￥" + row.subtotal
        : "￥" + row.subtotal.toFixed(2)
    },
    getData() {
      listPay({
        appNo: this.id,
      }).then((res) => {
        this.tableData = res.data.list
        this.proActPay = res.data.proActPay
      })

      getUserProfile().then((res) => {
        this.user = res.user
      })
    },
    handleRefresh() {
      getUserProfile().then((res) => {
        this.user = res.user
      })
    },
    async sendValidCode() {
      if (!this.canSend) {
        return
      }
      this.canSend = false
      try {
        let result = await sendUserCodeSms()
        let timer = window.setInterval(() => {
          this.remain--
          this.validText = `${this.remain}s后重新获取`
          if (this.remain == 0) {
            this.canSend = true
            this.remain = 60
            window.clearInterval(timer)
            this.validText = "发送验证码"
          }
        }, 1000)
      } catch (error) {
        this.canSend = true
      }
    },
    toPay() {
      this.showConfirmDialog = true
      this.validCode = ""
    },
    handlePayOrder() {
      // if (this.validCode.trim() == "") {
      //   this.msgError("请输入验证码")
      //   return
      // }
      this.$confirm("请确认是否支付订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderPay({
          appNo: this.id,
          // captcha: this.validCode,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("订单支付失败")
          } else {
            this.$message.success("订单支付成功", 1000)

            setTimeout(() => {
              let platNo = this.$route.query.platNo
              if (platNo && platNo == "05") {
                this.$router.push({
                  path: "/order/myOrder/orderShopee",
                })
                return
              } else if (platNo && platNo == "03") {
                this.$router.push({
                  path: "/order/myOrder/orderLazada",
                })
                return
              }
              this.$router.push({
                path: "/order/myOrder/orderTiktok",
              })
            }, 1000)
          }
        })
      })
      this.$confirm
    },
    handleJump(path) {
      this.$router.push({ path: path })
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style scoped>
.font-bold {
  font-weight: bold;
}

.pt20 {
  padding-top: 20px;
}

.pb30 {
  padding-top: 30px;
}

.pr20 {
  padding-right: 20px;
}

.pl20 {
  padding-left: 20px;
}

.f14 {
  font-size: 14px;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.ml10 {
  margin-left: 10px;
}

.mr10 {
  margin-right: 10px;
}

.mr5 {
  margin-right: 5px;
}

.ml5 {
  margin-left: 5px;
}

.mt5 {
  margin-top: 5px;
}

.mb5 {
  margin-bottom: 5px;
}
.mt30 {
  margin-top: 30px !important;
}
.mt20 {
  margin-top: 20px;
}
.mr30 {
  margin-right: 30px !important;
}

.ml30 {
  margin-left: 30px !important;
}
.mb20 {
  margin-bottom: 20px !important;
}
.f34 {
  font-size: 34px;
}
.pay-tree > li {
  display: inline-block;
  margin: 10px 0;
  font-size: 14px;
  color: #333;
  border: 1px solid #ddd;
  text-align: center;
  height: 45px;
  line-height: 45px;
  position: relative;
  cursor: pointer;
  margin-right: 20px;
  width: 143px;
}
.pay-tree > li.checked {
  border-color: #4934b2;
}

.pay-tree > li.checked {
  border-color: #4934b2;
  position: relative;
}

.pay-tree > li.checked > .check-icon {
  position: absolute;
  background: #4934b2;
  display: inline;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 15px;
  color: #fff;
}

.recharge-bar {
  background: #eef5fa;
  border: 1px solid #4934b2;
  padding: 12px 15px;
  margin-left: 70px;
}
.cr {
  color: #ed4e2a;
}
.blue {
  color: #4934b2 !important;
}
.table {
  font-size: 12px;
}

.display-flex {
  display: flex;
  align-items: center;
}

.get-pay {
  font-size: 14px;
}

.pay-cont-box {
  min-height: 500px;
  background: #fff;
  padding: 20px;
  font-size: 12px;
}

.pay-cont-box .top {
  border: 1px solid #ebeef5;
  height: 38px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  padding: 10px;
  border-bottom: 0;
}

.pay-cont-box .close-btn {
  padding: 12px 52px;
  color: #fff;
  font-size: 18px;
  border-radius: 4px;
}

.title_record_style {
  margin: 10px 0px 10px 0px;
  border: 1px solid #fae0b3;
  padding: 8px 10px;
  background: #fff8e5;
  color: #bc861e;
}
</style>
